export default "__VITE_ASSET__CxM02owj__"